// extracted by mini-css-extract-plugin
export default {"footerWrapper":"footer_footerWrapper__IKvCk","firstCol":"footer_firstCol__RFGdg","info":"footer_info__d0Sn7","nav":"footer_nav__Ul-bT"};